<template>
  <v-card tile>
    <v-row style="display: flex; align-items: end" class="mt-2">
      <v-col cols="12" md="2">
        <v-card-title style="justify-content: center">{{
          $t("locationsTitle")
        }}</v-card-title>
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          v-if="isMultipleCountries"
          :items="countryOptions"
          item-text="label"
          item-value="id"
          :label="$t('locationsSelectCountry')"
          v-model="selectedCountryId"
          dense
          class="pl-2 pr-2"
        ></v-select>
      </v-col>
    </v-row>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" style="width: 180px">
              {{ $t("locationsCountry") }}
            </th>
            <th class="text-left">{{ $t("locationsCity") }}</th>
            <th class="text-left">{{ $t("locationsName") }}</th>
            <th class="text-left">{{ $t("locationsRole") }}</th>
            <th class="text-left">{{ $t("locationsManage") }}</th>
            <th class="text-right">{{ $t("locationsBalance") }}</th>
            <th class="text-right">{{ $t("locationsStatus") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="location in filteredLocations" :key="location.id">
            <td>{{ location.country.name }}</td>
            <td>{{ location.city }}</td>
            <td>{{ location.name }}</td>
            <td>{{ location.role.value }}</td>
            <td style="display: flex; align-items: center">
              <v-btn
                v-if="checkPermission('accounts.anvio.multibooking')"
                text
                :to="{
                  name: 'multibooking_admin',
                  params: { location_id: location.id },
                }"
                icon
                :title="$t('navMultiBookingAdmin')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    d="M17 7h6v16H7v-4m16-8h-6M13 0v3M1 7h16M1 3h16v16H1V3Zm4-3v3m-1 8h2m2 0h6M4 15h2m2 0h6"
                  />
                </svg>
              </v-btn>
              <v-btn
                text
                :to="{
                  name: 'booking_admin',
                  params: { location_id: location.id },
                }"
                icon
                :title="$t('navBookingAdmin')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M12 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm-5 4a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1ZM7 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1ZM19 4h-1V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16Zm0-11H4V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM7 18a1 1 0 1 0-1-1a1 1 0 0 0 1 1Z"
                  />
                </svg>
              </v-btn>
              <v-btn
                  v-if="checkPermission('accounts.anvio.certificate')"
                  text
                  :to="{
                  name: 'certificates',
                  params: { location_id: location.id },
                }"
                  icon
                  :title="$t('navCertificates')"
              >
                <v-icon>mdi-certificate</v-icon>
              </v-btn>
              <v-btn
                v-if="location.role.id == 40"
                text
                :to="{
                  name: 'location_management',
                  params: { location_id: location.id },
                }"
                icon
                :title="$t('navLocationManagement')"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <!--            <v-btn-->
              <!--                v-if="location.role.id == 40"-->
              <!--                text-->
              <!--                :to="{name: 'tools', params: { location_id: location.id}}"-->
              <!--                icon-->
              <!--                :title="$t('navTools')"-->
              <!--            >-->
              <!--              <v-icon>mdi-tools</v-icon>-->
              <!--            </v-btn>-->
              <!--            <v-btn-->
              <!--                v-if="location.role.id == 40"-->
              <!--                text-->
              <!--                :to="{name: 'statistic', params: { location_id: location.id}}"-->
              <!--                icon-->
              <!--                :title="$t('navStatistic')"-->
              <!--            >-->
              <!--              <v-icon>mdi-chart-line</v-icon>-->
              <!--            </v-btn>-->
            </td>
            <td align="right" v-html="convertPrice(location)"></td>
            <td align="center" style="width: 20px">
              <v-icon v-if="location.is_active" style="color: green"
                >mdi-circle</v-icon
              >
              <v-icon v-else style="color: red">mdi-circle</v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import getDefaultStartDate from "../mixins/helper";
import getDefaultEndDate from "../mixins/helper";

export default {
  name: "LocationsTable",

  mixins: [getDefaultStartDate, getDefaultEndDate],

  data() {
    return {
      countryOptions: [
        { id: null, label: this.$i18n.t("locationsAllCountries") },
      ],
      selectedCountryId: null,
    };
  },

  computed: {
    ...mapGetters(["locations", "checkPermission"]),
    filteredLocations() {
      if (this.selectedCountryId) {
        return this.locations.filter(
          (location) => location.country.id === this.selectedCountryId
        );
      }
      return this.locations;
    },
    isMultipleCountries() {
      if (this.locations.map((location) => location.country).length > 1) {
        this.countryOptions = [
          ...this.countryOptions,
          ...this.locations.map((location) => ({
            id: location.country.id,
            label: location.country.name,
          })),
        ];
        return true;
      }
    },
  },

  methods: {
    convertPrice(location) {
      if (location.balance) {
        let currency = location.b2b_currency;
        let price = new Intl.NumberFormat(
          navigator.language.split("-")[0]
        ).format(location.balance);

        if (currency === null) {
          return this.$i18n.t("CurrencyTitle");
        } else {
          if (currency.is_before) {
            return (
              currency.code +
              currency.blank_place +
              `<strong class="${
                location.balance > 0 ? "green--text" : "red--text"
              }">` +
              price +
              "</strong>"
            );
          } else {
            return (
              `<strong class="${
                location.balance > 0 ? "green--text" : "red--text"
              }">` +
              price +
              "</strong>" +
              currency.blank_place +
              currency.code
            );
          }
        }
      }
    },
  },
};
</script>
